import React from 'react'
import icons from './../../../utils/import.icons'
import mobileAndTabletCheck from './../../../utils/mobileCheck'

let imageSize = ["100vw", "100vh"];
let barOffset = 0;
if (mobileAndTabletCheck() && window.innerHeight > window.innerWidth) {
  barOffset = 5;
  imageSize = ["calc(84vh * 1.77778)", "84vh"];
}

let Amenities: any = [
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [798.15, 823.223]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [847.514, 797.536]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [884.492, 861.966]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1025.03, 836.422]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1043.95, 769.42]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1144.62, 814.581]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [795.926, 818.848]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [851.715, 794.779]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [868.577, 859.197]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1016.07, 837.741]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1054.55, 771.158]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1144.42, 818.964]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [795.076, 814.522]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [853.8, 856.048]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [856.664, 792.171]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1006.66, 838.837]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1064.77, 773.14]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1142.88, 823.401]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [795.554, 810.275]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [840.293, 852.56]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [862.312, 789.724]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [996.895, 839.695]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1074.54, 775.362]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1139.94, 827.857]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [797.303, 806.129]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [828.164, 848.773]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [868.608, 787.442]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [986.87, 840.298]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1083.79, 777.816]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1135.57, 832.286]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [800.264, 802.103]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [817.502, 844.727]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [875.504, 785.329]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [976.678, 840.629]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1092.47, 780.489]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1129.73, 836.638]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [804.374, 798.214]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [808.367, 840.462]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [882.95, 783.388]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [966.417, 840.675]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1100.49, 783.37]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1122.41, 840.859]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [800.801, 836.025]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [809.56, 794.479]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [890.891, 781.624]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [956.194, 840.43]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1107.78, 786.444]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1113.63, 844.893]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [794.815, 831.461]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [815.749, 790.916]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [899.275, 780.041]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [946.11, 839.893]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1103.41, 848.687]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1114.27, 789.696]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [790.402, 826.823]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [822.863, 787.542]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [908.048, 778.647]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [936.268, 839.073]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1091.82, 852.193]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1119.9, 793.113]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [787.531, 822.159]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [830.824, 784.374]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [917.153, 777.45]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [926.764, 837.987]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1078.94, 855.369]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1124.58, 796.682]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [786.153, 817.519]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [839.552, 781.43]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [917.688, 836.656]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [926.539, 776.457]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1064.88, 858.179]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1128.25, 800.389]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [786.21, 812.945]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [848.972, 778.722]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [909.122, 835.104]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [936.155, 775.678]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1049.79, 860.59]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1130.86, 804.22]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [787.633, 808.477]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [859.012, 776.263]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [901.137, 833.356]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [945.949, 775.118]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1033.8, 862.577]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1132.34, 808.158]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [790.349, 804.143]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [869.605, 774.059]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [893.797, 831.433]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [955.874, 774.781]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1017.08, 864.111]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1132.63, 812.178]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [794.289, 799.963]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [880.689, 772.11]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [887.159, 829.351]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [965.884, 774.663]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [999.823, 865.162]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1131.68, 816.248]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [799.379, 795.95]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [881.273, 827.118]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [892.204, 770.413]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [975.926, 774.758]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [982.216, 865.696]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1129.43, 820.323]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [805.552, 792.107]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [876.186, 824.735]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [904.092, 768.959]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [964.47, 865.673]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [985.951, 775.051]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1125.84, 824.344]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [812.719, 788.457]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [871.923, 822.236]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [916.287, 767.754]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [946.804, 865.105]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [995.904, 775.548]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1120.89, 828.278]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [820.785, 785.034]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [868.494, 819.668]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [929.429, 864.033]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [928.726, 766.815]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1005.74, 776.26]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1114.59, 832.108]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [829.668, 781.853]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [865.904, 817.06]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [912.542, 862.484]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [941.353, 766.147]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1015.41, 777.193]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1106.95, 835.802]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [839.29, 778.922]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [864.153, 814.435]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [896.33, 860.484]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [954.113, 765.752]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1024.85, 778.344]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1098.01, 839.32]
        ]
    }, ],
    [{
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [849.58, 776.246]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [863.235, 811.808]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [880.967, 858.056]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [966.954, 765.626]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1034.03, 779.707]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1087.8, 842.612]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [866.61, 855.227]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [860.471, 773.825]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [863.139, 809.195]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [979.822, 765.766]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1042.89, 781.273]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1076.39, 845.629]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [853.4, 852.027]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [863.846, 806.606]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [871.892, 771.66]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [992.661, 766.167]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1051.36, 783.032]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1063.86, 848.319]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [841.451, 848.496]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [865.332, 804.057]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [883.778, 769.751]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1005.41, 766.826]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1050.32, 850.637]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1059.4, 784.974]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [830.859, 844.678]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [867.57, 801.561]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [896.062, 768.1]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1018.02, 767.741]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1035.9, 852.546]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1066.94, 787.09]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [821.688, 840.623]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [870.521, 799.137]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [908.677, 766.71]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1020.77, 854.014]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1030.42, 768.908]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1073.92, 789.368]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [813.976, 836.389]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [874.146, 796.803]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [921.559, 765.586]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1005.08, 855.026]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1042.55, 770.33]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1080.3, 791.805]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [807.74, 832.029]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [878.399, 794.578]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [934.648, 764.733]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [989.012, 855.576]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1054.36, 772.008]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1086, 794.392]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [802.972, 827.598]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [883.237, 792.481]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [947.884, 764.156]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [972.758, 855.665]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1065.78, 773.944]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1090.99, 797.124]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [799.649, 823.147]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [888.613, 790.526]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [956.501, 855.301]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [961.212, 763.859]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1076.76, 776.138]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1095.22, 799.993]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [797.735, 818.715]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [894.483, 788.725]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [940.425, 854.497]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [974.58, 763.845]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1087.23, 778.59]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1098.63, 802.986]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [797.187, 814.337]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [900.803, 787.083]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [924.71, 853.261]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [987.934, 764.111]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1097.12, 781.293]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1101.17, 806.085]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [797.955, 810.034]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [909.527, 851.599]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [907.528, 785.599]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1001.22, 764.653]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1102.8, 809.262]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1106.36, 784.232]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [799.995, 805.813]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [895.049, 849.506]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [914.62, 784.263]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1014.38, 765.455]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1103.45, 812.471]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1114.86, 787.382]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [803.233, 801.706]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [881.427, 847.015]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [922.027, 783.08]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1027.34, 766.515]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1103.09, 815.689]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1122.55, 790.729]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [807.581, 797.758]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [868.782, 844.194]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [929.7, 782.072]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1040.07, 767.848]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1101.71, 818.913]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1129.35, 794.28]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [812.956, 793.994]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [857.219, 841.092]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [937.592, 781.25]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1052.49, 769.458]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1099.28, 822.126]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1135.2, 798.027]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [819.286, 790.433]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [846.822, 837.752]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [945.66, 780.616]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1064.55, 771.343]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1095.8, 825.303]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1140.03, 801.955]
        ]
    }, ],
    [{
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [826.494, 787.085]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [837.662, 834.21]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [953.861, 780.171]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1076.2, 773.499]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1091.26, 828.41]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1143.75, 806.043]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [829.79, 830.498]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [834.512, 783.956]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [962.151, 779.911]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1085.67, 831.413]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1087.35, 775.92]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1146.29, 810.262]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [823.239, 826.65]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [843.269, 781.051]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [970.486, 779.831]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1079.05, 834.269]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1097.95, 778.593]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1147.58, 814.577]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [818.025, 822.699]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [852.693, 778.373]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [978.82, 779.926]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1071.42, 836.941]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1107.91, 781.51]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1147.53, 818.951]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [814.15, 818.681]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [862.717, 775.928]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [987.107, 780.194]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1062.84, 839.393]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1117.15, 784.658]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1146.09, 823.347]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [811.593, 814.634]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [873.268, 773.722]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [995.302, 780.634]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1053.37, 841.595]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1125.6, 788.027]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1143.21, 827.724]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [810.32, 810.597]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [884.28, 771.76]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1003.36, 781.244]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1043.09, 843.523]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1133.17, 791.608]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1138.87, 832.046]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [810.287, 806.608]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [895.685, 770.052]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1011.23, 782.029]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1032.1, 845.161]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1133.04, 836.276]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1139.79, 795.39]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [811.438, 802.701]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [907.422, 768.604]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1020.5, 846.496]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1018.88, 782.989]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1125.72, 840.377]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1145.39, 799.363]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [813.711, 798.909]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [919.432, 767.422]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [1008.4, 847.52]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1026.26, 784.128]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1116.95, 844.314]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1149.88, 803.515]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [817.044, 795.257]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [931.659, 766.51]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [995.933, 848.228]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1033.33, 785.443]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1106.75, 848.047]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1153.2, 807.83]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [821.373, 791.761]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [944.052, 765.868]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [983.215, 848.608]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1040.05, 786.931]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1095.19, 851.529]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1155.26, 812.284]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [826.637, 788.433]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [956.557, 765.491]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [970.375, 848.646]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1046.37, 788.578]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1082.33, 854.706]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1155.99, 816.842]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [832.781, 785.269]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [957.551, 848.315]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [969.126, 765.367]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1052.24, 790.363]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1068.28, 857.505]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1155.3, 821.449]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [839.737, 782.278]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [944.878, 847.61]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [981.697, 765.492]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1053.15, 859.874]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1057.61, 792.27]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1153.13, 826.06]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [847.426, 779.49]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [932.49, 846.57]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [994.221, 765.878]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1037.11, 861.809]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1062.45, 794.307]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1149.45, 830.658]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [855.779, 776.92]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [920.51, 845.223]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1006.65, 766.532]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1020.34, 863.296]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1066.72, 796.474]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1144.22, 835.211]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [864.729, 774.579]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [909.05, 843.593]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [1003.01, 864.319]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1018.92, 767.456]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1070.37, 798.765]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1137.45, 839.683]
        ]
    }, ],
    [{
        name: "Spa",
        tipo: "Spa",
        verts: [
            [874.218, 772.47]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [898.217, 841.696]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [985.318, 864.859]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1030.99, 768.649]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1073.38, 801.164]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1129.11, 844.022]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [888.107, 839.548]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [884.188, 770.594]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [967.466, 864.899]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1042.81, 770.104]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1075.69, 803.654]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1119.24, 848.174]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [878.806, 837.166]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [894.582, 768.949]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [949.658, 864.428]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1054.31, 771.815]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1077.28, 806.213]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1107.86, 852.077]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [870.39, 834.57]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [905.344, 767.535]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [932.105, 863.444]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1065.43, 773.776]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1078.11, 808.817]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1095.04, 855.669]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [862.919, 831.785]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [915.011, 861.958]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [916.417, 766.352]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1080.87, 858.896]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1076.11, 775.98]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1078.15, 811.444]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [856.441, 828.84]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [898.57, 859.991]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [927.744, 765.401]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1065.48, 861.707]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1077.37, 814.072]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1086.28, 778.42]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [850.986, 825.769]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [882.962, 857.577]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [939.27, 764.686]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1049.02, 864.06]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1075.76, 816.683]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1095.87, 781.092]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [846.571, 822.609]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [868.342, 854.762]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [950.939, 764.211]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1031.66, 865.929]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1073.33, 819.259]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1104.81, 783.993]
        ]
    }, ],
    [{
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [843.197, 819.397]
        ]
    }, {
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [854.844, 851.594]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [962.699, 763.981]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [1013.6, 867.29]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1070.05, 821.784]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1113.04, 787.118]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [842.577, 848.127]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [840.858, 816.168]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [974.5, 764.002]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [995.037, 868.136]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1065.96, 824.246]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1120.49, 790.465]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [831.628, 844.414]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [839.538, 812.953]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [976.194, 868.461]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [986.293, 764.276]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1061.06, 826.628]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1127.09, 794.027]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [822.059, 840.498]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [839.212, 809.776]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [957.29, 868.259]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [998.027, 764.805]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1055.38, 828.906]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1132.77, 797.791]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [813.92, 836.416]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [839.856, 806.654]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [938.544, 867.525]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1009.65, 765.583]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1048.94, 831.054]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1137.44, 801.735]
        ]
    }, ],
    [{
        name: "Biblioteca y sala de juntas",
        tipo: "Biblioteca y sala de juntas",
        verts: [
            [807.247, 832.195]
        ]
    }, {
        name: "Zona de niños",
        tipo: "Zona de niños",
        verts: [
            [841.442, 803.591]
        ]
    }, {
        name: "Lobby",
        tipo: "Lobby",
        verts: [
            [920.18, 866.248]
        ]
    }, {
        name: "Spa",
        tipo: "Spa",
        verts: [
            [1021.11, 766.6]
        ]
    }, {
        name: "Lounge juvenil",
        tipo: "Lounge juvenil",
        verts: [
            [1041.79, 833.028]
        ]
    }, {
        name: "Gimnasio y zona fitness",
        tipo: "Gimnasio y zona fitness",
        verts: [
            [1141.02, 805.827]
        ]
    }, ],
]
let amenitiess = []

interface Billboards{
    billboard: any
}

interface Props{
    amenity: any,
    angle: number,
    gallery: any,
    openGallery: any,
    show: boolean,
    leftOffset: number,
    zoom: number,
    topOffset: number
}

interface State{
    angle: number,
    pos: any,
    transition: boolean
}

class Billboards extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            angle: 0,
            pos: [],
            transition: false
        }
    }

    componentDidMount(){
        this.billboard = <div></div>
    }

    createBillboards = () => {
        
        if(this.props.amenity.Nombre !== ''){
            
            if(Amenities[this.props.angle].length > 0){
                
                this.billboard = <div></div>
                for(let i = 0; i < Amenities[this.props.angle].length; i++)
                {
                    if(Amenities[this.props.angle][i].name === this.props.amenity.Nombre){
  
                        
                        
                        /*this.setState(prevState => ({
                            pos: Amenities[this.props.angle][i].pos
                        }), 
                        () => {*/
                            this.billboard = <svg 
                            width={"100vw"}
                            height={"100vh"}
                            preserveAspectRatio="XminYmin slice"
                            viewBox="0 0 1920 1080"
                            style={{
                                overflow: 'hidden',
                                pointerEvents: 'none',
                                position: 'absolute'
                            }}>
                                <g style={{
                                    pointerEvents: this.props.show ? 'visibleFill':'none'
                                }}
                                onClick = {this.props.gallery.length > 0 ? this.props.openGallery:null}
                                onTouchStart = {this.props.gallery.length > 0 ? this.props.openGallery:null}
                                >
                                    <circle 
                                        cx={Amenities[this.props.angle][i].verts[0][0]} 
                                        cy={Amenities[this.props.angle][i].verts[0][1]} 
                                        r="30" 
                                        style = {{
                                            fill:"rgba(90,89,92,.85)",
                                            stroke:"rgba(255,255,255,.85)",
                                            strokeWidth:1
                                        }}
                                    />
                                    <image 
                                        href={icons[this.props.amenity.Nombre + '2']}
                                        width="30"
                                        height="30"
                                        x={Amenities[this.props.angle][i].verts[0][0]-15}
                                        y={Amenities[this.props.angle][i].verts[0][1]-15}
                                        /*style={{
                                            position: 'absolute',
                                            left:this.state.pos[0],
                                            top:this.state.pos[1]
                                        }}*/
                                        
                                    ></image>
                                </g>
                                
                            </svg>;
                            
                        //})
                        break;
                    }                    
                }
            } 
            else
            {
                this.billboard = <div></div>
            }
            
        }
    }

    componentDidUpdate(prevProps: any){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 5;
            imageSize = ['calc(84vh * 1.77778)', '84vh'];
        }
        else {
          imageSize = ['100vw', '100vh'];
          barOffset = 0;
        }
  
        // TODO: check if this routine can be optimized
        
        if(!this.props.show){
            return
        } 

        if(prevProps.amenity !== this.props.amenity){
            this.setState({transition:true})
            setTimeout(function(this: any){
                this.setState({
                    transition: false,
                })
                this.createBillboards();
                this.forceUpdate();   
            }.bind(this), 250)
        }
                
        if(prevProps.angle !== this.props.angle || prevProps.show !== this.props.show){
            //console.log(this.props)
            this.createBillboards();
            this.forceUpdate();        
        }
    }
  
    render() {
        return (
            <div
                style={{
                    pointerEvents: 'none',
                    width: imageSize[0],
                    height: imageSize[1],
                    transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc(' + barOffset + '% + ' + this.props.topOffset + '%))'
                }}
                className={this.props.show && !this.state.transition ? "billboards fade-in":"billboards fade-out"}
            >
                {this.billboard}
            </div>
            
        );
      
    }

}

export default Billboards